import { COMPONENT_TYPE_TEXT, ElementsTemplateGroupedByType } from '@entities/leadCollector';

export const getTextProperties = (templates: ElementsTemplateGroupedByType[]) => {
  const textTemplate = templates?.find(({ type }) => type === COMPONENT_TYPE_TEXT);
  const textElement = textTemplate?.elements?.find(({ elementType }) => elementType === COMPONENT_TYPE_TEXT);

  return textElement?.properties;
};
